module.exports = __webpack_public_path__ + "first-100-ir.jpg?40e9be91e54884cb6c0a4cea5ea1a00b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-100-ir.jpg
// module id = 416
// module chunks = 0